import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppLayout } from "../layout/Header";
import { SharedButton, SharedCard, SharedProgressBar } from "../shared";
import { useSellerState } from "../../js/state/sellerState";
import { nextSellerPath, prevSellerPath, sellerProgress } from "../../js/utils/sellerSteps";
import { useAutosave } from "../../js/hooks/useAutosave";
import { useGuestMode } from "../../js/hooks/useGuestMode";
import { toTitleCase } from "../../js/utils/titleCase";
import GuestLockShell from "../guest/GuestLockShell";

export default function SellerStep({
  title,
  lead,
  sectionKey,
  value,
  children,
  continueLabel = "Continue",
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const { seller, updatePortfolio } = useSellerState();
  const { canPersist } = useGuestMode();
  const progress = sellerProgress(seller.portfolio);

  const persist = useCallback(
    (nextValue) => {
      if (!canPersist || !sectionKey) return;
      updatePortfolio(sectionKey, nextValue);
    },
    [canPersist, sectionKey, updatePortfolio]
  );

  useAutosave(canPersist ? value : null, persist);

  function continueNext() {
    if (canPersist) persist(value);
    navigate(nextSellerPath(location.pathname));
  }

  function goBack() {
    if (canPersist) persist(value);
    navigate(prevSellerPath(location.pathname));
  }

  return (
    <AppLayout variant="seller" showSellerNav>
      <div className="seller-hero" data-tour="seller-frame">
        <h1 className="section-title">{toTitleCase(title)}</h1>
        {lead ? <p className="page-lead">{lead}</p> : null}
        <div className="title-rule" />
        <div className="progress-wrap">
          <SharedProgressBar percent={progress.percent} />
        </div>
      </div>
      <SharedCard>
        <GuestLockShell>{children}</GuestLockShell>
      </SharedCard>
      <div className="wizard-actions">
        <SharedButton variant="secondary" onClick={goBack}>
          Back
        </SharedButton>
        <SharedButton variant="primary" onClick={continueNext}>
          {continueLabel}
        </SharedButton>
      </div>
    </AppLayout>
  );
}
